import React, { SVGProps } from 'react'

import darkSpinnerSvg from '~/assets/images/sprite/spinner-dark.svg'

import { StyledSpinner as S } from './Spinner.styles'

interface IProps extends SVGProps<SVGSVGElement> {
  isFullScreen?: boolean
  height?: number
  className?: string
}

export const Spinner: React.FC<IProps> = ({
  isFullScreen = true,
  height = 76,
  className,
}) => {
  return isFullScreen ? (
    <S.Wrapper className={className}>
      <S.Circle svg={darkSpinnerSvg} height={height} />
    </S.Wrapper>
  ) : (
    <S.Circle svg={darkSpinnerSvg} height={height} />
  )
}
